<template lang="html">
   <div class="info" v-if="connection != null">
  <div class="info" @click="toggle()" v-if="title != 'false'">{{connection.platform.name}} {{connection.showinfo}}</div>
  <div class="info" v-if="show" style="padding-left:0px;padding-top:5px;font-size:0.9em;width:300px;">
    <template v-if="canSeeCredentials">
      <div class="info">
        <div class="icon"><i class="fa fa-user"></i></div><span>{{connection.login}}</span>
      </div>
      <div class="info">
        <div class="icon"><i class="fa fa-key"></i></div>
        <div class="button is-small" @click="copyPass()">password</div>
      </div>
      <textarea class="hide is-pulled-left" ref="pass">{{connection.password}}</textarea>
    </template>
    <div class="info">
      <pre>{{connection.info}}</pre>
    </div>
    <div class="info"><a :href="connection.establishment_link" target="_blank" style="display:block;;text-overflow:ellipsis;overflow:hidden;">{{connection.establishment_link}}</a></div>
  </div>
</div>

</template>


<script>
export default {
  name: "ConnectionInfo",
  props: {
    connection: Object,
    title: {
      type: [String, Boolean],
      default: false
    },
    opened: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    canSeeCredentials() {
      return this.$store.state.profile && this.$store.state.profile.is_superuser;
    }
  },
  data() {
    return {
      show: this.opened ? this.opened : false
    };
  },
  methods: {
    toggle() {
      this.show = !this.show;
    },
    copyPass() {
      const el = this.$refs && this.$refs.pass ? this.$refs.pass : null;
      if (el) {
        console.log(el);
        el.select();
        document.execCommand('copy');
        this.$store.dispatch("notify", {
          level: "success",
          text: "Copié!",
          seconds: 2
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.pad {
    padding: 0;
    width: 100%;
}
.hide{
    opacity: 0; 
    width:0px;
    height:0px;
}
pre{
    padding:0;
    background:#FFF;
    width:100%;
    white-space: pre-wrap;
}
</style>

